if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    const { RichText } = window.wp.editor;

    registerBlockType('custom-gutenberg/feature', {
        title: 'Feature',
        description: 'Numbered feature with a heading, text and top border.',
        icon: 'editor-ol',
        category: 'custom-content',
        example: {},

        attributes: {
            number: { type: 'string', default: '' },
            title: { type: 'string', default: '' },
            text: { type: 'string', default: '' }
        },

        edit({ attributes, setAttributes }) {
            const { number, title, text } = attributes;

            return (
                <div className="process-step">
                    <RichText tagName="span" value={ number } placeholder="01" allowedFormats={ [] } onChange={ number => setAttributes({ number: number }) } />
                    <RichText tagName="h3" value={ title } placeholder="Naslov" onChange={ title => setAttributes({ title: title }) } />
                    <RichText tagName="p" value={ text } placeholder="Opis" onChange={ text => setAttributes({ text: text }) } />
                </div>
            );
        },

        save({ attributes }) {
            return (
                <div className="process-step">
                    <RichText.Content tagName="span" value={ attributes.number } />
                    <RichText.Content tagName="h3" value={ attributes.title } />
                    <RichText.Content tagName="p" value={ attributes.text } />
                </div>
            );
        }
    });
}
